import { api } from './client.js';
import { WEB_API_PREFIX } from '../config.js';

/*
 * Subscriptions and crypto checkout. All live in production.
 *
 *   GET  /api/web/pricing
 *   GET  /api/web/subscription
 *   POST /api/web/subscribe/{tier}    -> {invoice_url}
 *   GET  /api/web/payment/{id}/status
 *
 * Prices are ALWAYS whatever getPricing() returns. The client never sends an
 * amount and never displays one it made up.
 */

/** Tier list with server-side prices. Requires a signed-in session. */
export function getPricing() {
  return api.get(`${WEB_API_PREFIX}/pricing`, { auth: true });
}

/** The caller's current subscription (or a 'free' shape if they have none). */
export function getSubscription() {
  return api.get(`${WEB_API_PREFIX}/subscription`, { auth: true });
}

/**
 * Start a purchase. Returns a NOWPayments hosted invoice URL that the user is
 * sent to; we never handle card or wallet details ourselves.
 *
 * VIP is rejected with a 400 by design — it delivers a private Telegram channel
 * invite that a web-only account cannot receive.
 */
export function subscribe(tier) {
  return api.post(`${WEB_API_PREFIX}/subscribe/${encodeURIComponent(tier)}`, { auth: true });
}

/** Poll a payment. The backend refreshes from NOWPayments while it's in flight. */
export function getPaymentStatus(paymentId) {
  return api.get(`${WEB_API_PREFIX}/payment/${encodeURIComponent(paymentId)}/status`, {
    auth: true,
  });
}

/** Payment states that mean "stop polling". */
export const TERMINAL_PAYMENT_STATUSES = ['confirmed', 'failed', 'expired', 'refunded'];

export function isPaymentSettled(status) {
  return TERMINAL_PAYMENT_STATUSES.includes(status);
}
